import { useCallback, useMemo, useRef } from 'react';
import useRequestOwnership from './useRequestOwnership';

/** A synchronous lock belongs to one target/session; old completions cannot unlock a new operation. */
export default function useOwnedMutation(scope: string, invalidate?: () => void) {
  const { begin } = useRequestOwnership(scope);
  const busy = useRef<null | (() => boolean)>(null);
  const invalidateRef = useRef(invalidate); invalidateRef.current = invalidate;
  const start = useCallback(() => {
    if (busy.current?.()) return null;
    const current = begin('mutation');
    if (!current()) return null;
    busy.current = current;
    invalidateRef.current?.();
    return { current, finish: () => { if (busy.current === current) busy.current = null; } };
  }, [begin]);
  const isBusy = useCallback(() => Boolean(busy.current?.()), []);
  return useMemo(() => ({ start, isBusy }), [start, isBusy]);
}
